import { Component, ElementRef, Input, OnInit,OnChanges,OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { DatePipe } from '@angular/common'
import { EquipmentsUtilization, EquipmentsUtilizationChartModel, EquipmentsChartModelItem, UtilizationFilter, UtilizationType, DonutModel, ReportMapEntry, EquipmentsUtilizationItem, DaysUtilization } from '../../services/stats.model';
import { StatsService } from '../../services/stats.service';
import { Subscription } from 'rxjs';
import { HaloToastService,EToastType  } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloCustomLoaderService,HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
export var multi = [];

var _this: any;
@Component({
  selector: 'app-equipment-utilization',
  templateUrl: './equipment-utilization.component.html',
  styleUrls: ['./equipment-utilization.component.scss']
})

export class EquipmentUtilization implements OnInit {
  rowData: EquipmentsUtilization;
  dateFrom = new Date().setDate(new Date().getDate() - 90);;
  dateTo = new Date().setDate(new Date().getDate() - 1);
  selectedFacility: FacilityObject;
  operatingHours = "";
  canEdit = false;
  chartData: EquipmentsUtilization = { 'equipmentsUtilization': [] };
  hideSeries = false;
  [x: string]: any;
  multi: any[];
  clonedMultiObject: any;
  view: any[] = [700, 300];
  utilization = true;
  isAllDisabled = true;
  openingHoursVisible = false;
  colorSchemeArray: string[] = [];
  filterData: UtilizationFilter[] = []
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = false;
  yAxisLabel: string = this.commonUtil.translateText('PERCENTAGE.UTILIZATION');
  timeline: boolean = true;
  isInsigniaExist = false;
  insigniaCount = '0';
  colorScheme = {
    domain: this.colorSchemeArray
  };
  private sub = new Subscription();
  public previousWidthOfResizedDiv: number = 0;

  @Input() equipmentColorMap: any[];
  @Input() productMixData: any;
  @ViewChild('resizedDiv') resizedDiv: ElementRef;
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  facilityChange = false;
  constructor(
    private commonUtil: CommonUtil,
    private _subscriptionService: StatsService,
    private _facilityService: FacilityService,
    public datepipe: DatePipe,
    private haloCustomLoaderService: HaloCustomLoaderService,
  ) {
    Object.assign(this, { multi });
    _this = this;
  }

  async ngOnInit() {
    const facilitySub = this._facilityService.selectedFacilitySource.subscribe(async(res) => {
      this.selectedFacility = res;
      if (res.summary.facilityRights.stats !== 'false' && res.summary.userRights.stats !== 'H'){
        this.openingHoursVisible = false;
        this.canEdit = res.summary.userRights.stats === 'F';
        this.filterData = [];
        this.facilityChange = true;
        this.getData();
      }
    });
    this.selectedFacility = this._facilityService.selectedFacility();
    this.filterData = [];
    this.getData();
    this.canEdit = this._facilityService.selectedFacility().summary.userRights.stats === 'F';
    this.sub.add(facilitySub);
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.productMixData && changes.productMixData.currentValue && changes.productMixData.currentValue !== changes.productMixData.previousValue){
      this.insigniaCount = this.productMixData.productMix.find((val:any) => val.activityId === '10001')?this.productMixData.productMix.find((val:any) => val.activityId === '10001').noOfEquips:'0';
      this.isInsigniaExist = this.productMixData.productMix.find((val:any) => val.activityId === '10001')?true:false;
      if(this.rowData) {
        if (!(this.rowData && this.rowData.equipmentsUtilization.find(val => val.equipmentId === '10001') ? true : false) && this.isInsigniaExist) {
          let tmpData = this.loadDefaultInsigniaData();
          this.rowData.equipmentsUtilization.push(tmpData);
          this.filterData = [];
          this.confiruChart(this.rowData);
          let ind = this.filterData.findIndex(x => (x.type === 10001));
          if(ind === -1) {
            this.filterData.push({value: false, colour: '#CC99CC', type: 10001, count: Number(this.insigniaCount)});
            let allFilter = this.filterData.find(x => x.type === -1);
            if(allFilter) {
              allFilter.count += Number(this.insigniaCount);
            }
          }
        } else if(!this.isInsigniaExist && this.rowData.equipmentsUtilization.findIndex(val => val.equipmentId === '10001') === -1) {
          for (let i = this.filterData.length - 1; i >= 0; i--) {
            let ind = this.filterData.findIndex(x => (x.type === 10001));
            if(ind != -1) {
              this.filterData.splice(ind, 1);
            }
          }
        } else {
          let allCount = this.rowData.equipmentsUtilization.find(x => x.equipmentId === '-1');
          if(this.filterData && this.filterData.length > 0) {
            this.filterData[0].count = Number(allCount ? allCount.equipCount : 0);
          }
        }
      }
    }
  }

  loadDefaultInsigniaData() :EquipmentsUtilizationItem{
    let data: EquipmentsUtilizationItem ;
    data = {daysUtilization: [], equipCount: this.insigniaCount, equipmentId: '10001' }
    data.equipmentId = "10001";
    this.rowData.equipmentsUtilization[0].daysUtilization.forEach(item => {
      data.daysUtilization.push({
        date: item.date,
        dayNo: item.dayNo,
        dormancy: '100',
        equipCount: data.equipCount,
        totalHours: '0',
        utilization: '0.0'
      })
    });

    return data;
  }

  getData() {
    this.customLoaderIsLoading = true;
    const utilizationSub = this._subscriptionService.getUtilization(this._facilityService.selectedFacilityId(), new Date().getTimezoneOffset()).subscribe((data: EquipmentsUtilization) => {
      this.customLoaderIsLoading = false;
      if(!Array.isArray(data.equipmentsUtilization)){
        let tmp  = data.equipmentsUtilization;
        data.equipmentsUtilization = [tmp as any];
      }
      // make sure the date displayed is base on facility timezone
      data.equipmentsUtilization.forEach(eq => {
        eq.daysUtilization.forEach(d => {
          let [year, month, day] = d.date.split('T')[0].split("-");
          d.date = this.toTimezoneDate(new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 0), this.selectedFacility.summary.timezone).toDateString();
        });
      });
      if(this.facilityChange) {
        this.filterData = [];
        this.facilityChange = false;
      }
      this.rowData = data;
      this.confiruChart(data);
    },err => {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
    });
    this.sub.add(utilizationSub);
  }

  confiruChart(data: EquipmentsUtilization) {
    this.chartData.equipmentsUtilization = [];
    this.colorScheme.domain = ['#ccc'];
    this.colorSchemeArray = ['#ccc'];
    let insigniaEquipmentUsageInPast90Days = false;
    insigniaEquipmentUsageInPast90Days = data.equipmentsUtilization.find(val => val.equipmentId === '10001') ? true : false;
    if(!insigniaEquipmentUsageInPast90Days && this.isInsigniaExist){
      let c = this.equipmentColorMap.find(x => x.id == '10001');
      let itemIndex = this.filterData.findIndex(x => x.type == 10001);
      if(itemIndex == -1) {
        this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number('10001'), count: Number(this.insigniaCount) });
      } else{
        this.filterData[itemIndex] = { value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number('10001'), count: Number(this.insigniaCount) };
      }

    }
    data.equipmentsUtilization.forEach(eq => {
      let c = this.equipmentColorMap.find(x => x.id == eq.equipmentId);
      this.colorSchemeArray.push(c && c.colour ? c.colour : '#ccc');
      if (eq.equipmentId == '-1') {
        let newitem = { value: true, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.equipmentId), count: Number(eq.equipCount) };
        let existingItem = this.filterData.filter(x => x.type === Number(eq.equipmentId));
        if (existingItem.length === 0) {
          this.filterData = [newitem].concat(this.filterData);
          this.colorScheme.domain.push('#ccc');
        } else {
          existingItem[0] = newitem;
        }
      } else {
        let newItem = { value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.equipmentId), count: Number(eq.equipCount) };
        let existingItem = this.filterData.findIndex(x => x.type === Number(eq.equipmentId));
        existingItem === -1 ? this.filterData.push(newItem) : this.filterData[existingItem] = newItem;
        this.colorScheme.domain.push(c.colour);
      }
    });

    var initialIndex = data.equipmentsUtilization.findIndex(x => x.equipmentId == '-1');
    this.chartData.equipmentsUtilization.push(data.equipmentsUtilization[initialIndex]);
    this.multi = new EquipmentsUtilizationChartModel(this.chartData, this.utilization ? UtilizationType.Utilization : UtilizationType.Dormancy).equipmentsUtilizationChartModel;
    this.clonedMultiObject = this.multi;
    let selectedFacility = this._facilityService.selectedFacility();
    this.operatingHours = this.getDiference(Number(selectedFacility.summary.facilityHoursStart), Number(selectedFacility.summary.facilityMinsStart), Number(selectedFacility.summary.facilityHoursEnd), Number(selectedFacility.summary.facilityMinsEnd));
  }

  switchData() {
    this.yAxisLabel = this.commonUtil.translateText(this.utilization ? 'PERCENTAGE.DORMANCY' : 'PERCENTAGE.UTILIZATION');
    this.utilization = !this.utilization;
    this.multi = new EquipmentsUtilizationChartModel(this.chartData, this.utilization ? UtilizationType.Utilization : UtilizationType.Dormancy).equipmentsUtilizationChartModel;
  }

  reloadChartData($event: any) {
    this.openingHoursVisible = $event.visible;
    if ($event.facilityHoursStart != null) {
      this.customLoaderIsLoading = true;
      const utilizationSub = this._subscriptionService.getUtilization(this._facilityService.selectedFacilityId(), new Date().getTimezoneOffset(), $event.facilityHoursStart, $event.facilityMinsStart, $event.facilityHoursEnd, $event.facilityHoursEnd == 24 ? 0 : $event.facilityMinsEnd).subscribe((data: EquipmentsUtilization) => {
        this.customLoaderIsLoading = false;
        this.filterData = [];
        this.chartData.equipmentsUtilization = [];
        this.multi = [];
        this.rowData = data;
        this.filterData = [];
        this.confiruChart(data);
        this.isAllDisabled = true;
      },err => {
        this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
      });
      this.sub.add(utilizationSub);
    }
  }

  getColour(i: number) {
    return this.colorScheme.domain[i];
  }

  changeSelectAll(item: UtilizationFilter) {
    let i = this.filterData.findIndex(x => x.type == item.type);
    this.filterData[i].value = !this.filterData[i].value;
    this.colorScheme.domain = [];
    this.chartData.equipmentsUtilization = [];
    if (this.filterData.findIndex(x => x.value) === -1) {
      this.filterData[0].value = true;
      let tmp = this.rowData.equipmentsUtilization.find(x => x.equipmentId == '-1');
      if (tmp) {
        this.chartData.equipmentsUtilization.push(tmp);
        this.colorScheme.domain.push('#ccc');
        this.isAllDisabled = true;
      }
    } else {
      let insigniaChecked = false;
      let insigniaEquipmentUsageInPast90Days = false;
      insigniaEquipmentUsageInPast90Days = this.rowData.equipmentsUtilization.find(val => val.equipmentId === '10001') ? true : false;
      insigniaChecked = this.filterData.find(val => val.type === 10001)?.value === true ? true : false;

      this.filterData.forEach(filterItem => {
        if (filterItem.value) {
          let tmp = this.rowData.equipmentsUtilization.find(x => x.equipmentId == filterItem.type.toString());
          if (tmp) {
            this.chartData.equipmentsUtilization.push(tmp);
            this.colorScheme.domain.push(filterItem.colour);
          }
        }
      });

      if (!insigniaEquipmentUsageInPast90Days && insigniaChecked) {
        let c = this.equipmentColorMap.find(x => x.id == '10001');
        this.chartData.equipmentsUtilization.push({ daysUtilization: this.getDefault90DaysUtilization(), equipCount: this.insigniaCount, equipmentId: "10001" });
        this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
      }

      this.isAllDisabled = false;
      if (this.filterData.filter(x => x.value).length === 1 && this.filterData.filter(x => x.value && x.type === -1).length > 0) {
        this.isAllDisabled = true;
      }
    }

    this.multi = new EquipmentsUtilizationChartModel(this.chartData, this.utilization ? UtilizationType.Utilization : UtilizationType.Dormancy).equipmentsUtilizationChartModel;

    this.multi.forEach(e => {
      e.name = this.commonUtil.translateText('EQ.TYPE.' + e.name);
    })
  }

  getDefault90DaysUtilization() {
    var datePipe = new DatePipe('en-US');
    let daysUtilization: DaysUtilization[] = [];
    let data: DaysUtilization[] = [];
    let currentDate = new Date();
    currentDate = new Date(currentDate.setDate(currentDate.getDate() - 1));
    let nDays = 91;
    let tmp = this.rowData.equipmentsUtilization.find(val => val.equipmentId === '-1');
    daysUtilization = tmp ? tmp.daysUtilization : [];
    daysUtilization.forEach(e =>{
      let t : DaysUtilization = {
        date: e.date,
        dayNo: e.dayNo,
        dormancy: '100',
        equipCount: this.insigniaCount,
        totalHours: e.totalHours,
        utilization: '0'
      };
      data.push(t);
    })
    return data;
  }


  axisFormat(val: any) {
    return new Date(val).getDay() == 1 ? _this.datepipe.transform(val, 'MMM. dd, y') : '';
  }

  getDiference(openingH: number, openingM: number, closingH: number, closingM: number) {
    let startDate = new Date();
    startDate.setHours(openingH);
    startDate.setMinutes(openingM);

    let closetDate = new Date();
    closetDate.setHours(closingH);
    closetDate.setMinutes(closingM);

    let diference = Math.abs(startDate.getTime() - closetDate.getTime()) / 1000 / 60 / 60;
    let h = Math.floor(diference);
    let m
    if (h == 24) {
      m = 0;
      closingM = 0;
    } else {
      m = h == 24 ? 0 : ((diference - Math.floor(diference)) * 60).toFixed(2);
    }
    return (h < 10 ? '0' + h.toString() : h.toString()) + ':' + (Math.floor(Number(m)) === 0 ? '00' : Math.floor(Number(m)).toString()) + ' Hrs';
  }

  ngAfterViewChecked() {
    if (this.resizedDiv != undefined) {
      if (this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth) {
        this.multi = [...this.multi]
      }
      this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
    }
  }

  count(model: any) {
    return this.multi.find(x => x.name == model.series)?.count;
  }

  getFromSeries(model: any) {
    return [model[model.length - 1]];
  }

  getKey(model: any) {
    if (model) {
      if (isNaN(Number(model.series))) {
        return this.filterData.find(x => this.commonUtil.translateText('EQ.TYPE.' + x.type) === model.series)?.type;
      } else {
        return model.series;
      }
    }
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  toTimezoneDate(date: Date, timezone: string) {
    let timezoneDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }));
    let timeDiff = date.getTime() - timezoneDate.getTime();
    return new Date(timezoneDate.getTime() + (timeDiff * 2));
  }

  getFormat(date: string) {
    return 'MMM' + (new Date(date).getMonth() != 4 ? '. ': ' ') + 'dd, y';
  }
}
